import { render } from "./DocumentPreview.vue?vue&type=template&id=202c6a21&scoped=true"
import script from "./DocumentPreview.vue?vue&type=script&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&lang=js"

import "./DocumentPreview.vue?vue&type=style&index=0&id=202c6a21&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202c6a21"]])

export default __exports__